// Shared helpers for the live-session page.

export const formatMMSS = (totalSeconds) => {
    if (totalSeconds === null || totalSeconds === undefined) return "--:--";
    const s = Math.max(0, Math.floor(totalSeconds));
    const m = Math.floor(s / 60);
    const r = s % 60;
    return `${String(m).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
};

/**
 * For couple personas the LLM prefixes each utterance with "[Name]: text".
 * We split that into { speaker, content } so the UI can render the speaker
 * as a small label above the bubble instead of leaving "[Name]:" inline.
 *
 * Multi-speaker turns (the LLM speaks for both partners in one reply) are
 * split into multiple chunks, each with its own speaker label.
 */
export const splitCoupleTurn = (content) => {
    if (!content) return [{ speaker: null, content: "" }];
    const pattern = /\[([^\]]+)\]:\s*/g;
    const matches = [];
    let m;
    while ((m = pattern.exec(content)) !== null) {
        matches.push({ speaker: m[1].trim(), startIndex: m.index, headerEnd: m.index + m[0].length });
    }
    if (matches.length === 0) {
        return [{ speaker: null, content: content.trim() }];
    }
    const parts = [];
    for (let i = 0; i < matches.length; i++) {
        const cur = matches[i];
        const next = matches[i + 1];
        const text = content.slice(cur.headerEnd, next ? next.startIndex : content.length).trim();
        if (text) parts.push({ speaker: cur.speaker, content: text });
    }
    return parts.length ? parts : [{ speaker: null, content: content.trim() }];
};

export const counsellorInitials = (name) => {
    if (!name) return "?";
    return name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((s) => s[0].toUpperCase())
        .join("");
};
